import script from "./UploadPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadPanel.vue?vue&type=script&setup=true&lang=js"

import "./UploadPanel.vue?vue&type=style&index=0&id=b67a9f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b67a9f58"]])

export default __exports__